export default function getAppAndGroup() {
  return [
    {
      key: 1,
      app: "PCA",
      groups: [
        {
          key: "1",
          name: "Inteligência",
          help: (
            <>
              <p>
                §2o. O nível Inteligência poderá ser concedido aos integrantes
                das agências e subagências de inteligência formalmente criadas,
                no âmbito da Secretaria da Segurança Pública e Defesa Social e
                de suas vinculadas.
              </p>
              <p>
                §7º. Aos agentes de Segurança Pública lotados na
                Superintendência de Pesquisa e Estratégia de Segurança Pública
                (SUPESP) poderá ser concedido acesso no nível Inteligência I.
              </p>
            </>
          ),
        },
        {
          key: "2",
          name: "Investigação",
          help: "§3o. O nível Investigação poderá ser concedido aos integrantes da Polícia Civil do Ceará e da Perícia Forense do Ceará.",
        },
        {
          key: "3",
          name: "Operacional",
          help: "§4o. O nível Operacional poderá ser concedido aos integrantes da Polícia Militar do Ceará e do Corpo de Bombeiros Militar do Ceará.",
        },
        {
          key: "4",
          name: "Externo",
          help: "§6º. Aos demais agentes públicos, externos a SSPDS, que tenham a necessidade de utilizar o sistema PCA, poderá ser concedido acesso no nível Externo, sendo necessária a celebração de Termo de Cooperação Técnica com a SSPDS.",
        },
      ],
    },
    {
      key: 2,
      app: "CONSULTA INTEGRADA",
      groups: [
        {
          key: "1",
          name: "Inteligência I",
          help: "§2o. O nível Inteligência I poderá ser concedido aos integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Contrainteligência (Coordenadores, Diretores, Assessores e agentes lotados em Células de Contrainteligência formalizadas no âmbito da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE), bem como aos integrantes da Coordenadoria de Inteligência da Controladoria Geral de Disciplina dos Órgãos de Segurança Pública e do Sistema Penitenciário (COINT-CGD), com a limitação de, no máximo, 3 acessos por agência.",
        },
        {
          key: "2",
          name: "Inteligência II",
          help: "§3o. O nível Inteligência II poderá ser concedido aos demais integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Contrainteligência (agentes lotados em Células de Contrainteligência formalizadas no âmbito da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE), bem como aos demais integrantes da Coordenadoria de Inteligência da Controladoria Geral de Disciplina dos Órgãos de Segurança Pública e do Sistema Penitenciário (COINT-CGD).",
        },
        {
          key: "3",
          name: "Inteligência III",
          help: "§4o. O nível Inteligência III poderá ser concedido aos integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Inteligência propriamente dita (Coordenadores, Diretores, Assessores e agentes lotados em Células de Inteligência formalizadas no âmbito da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE), com a limitação de, no máximo, 3 acessos por agência.",
        },
        {
          key: "4",
          name: "Inteligência IV",
          help: "§5º. O nível Inteligência IV poderá ser concedido aos demais integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Inteligência propriamente dita (agentes lotados em Células de Inteligência formalizadas no âmbito da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE).",
        },
        {
          key: "5",
          name: "Inteligência V",
          help: (
            <>
              <p>
                §6o. O nível Inteligência V poderá ser concedido aos integrantes
                das agências de inteligência, no âmbito da Secretaria da
                Segurança Pública e Defesa Social (agentes lotados na
                COIN-SSPDS, no DIP-PCCE e na ASINT-PMCE), que executem
                atividades nas demais áreas de análise.
              </p>
              <p>
                §20. Aos agentes de Segurança Pública lotados na
                Superintendência de Pesquisa e Estratégia de Segurança Pública
                (SUPESP) poderá ser concedido acesso no nível Inteligência V.
              </p>
            </>
          ),
        },
        {
          key: "6",
          name: "Inteligência VI",
          help: "§7o. O nível Inteligência VI poderá ser concedido aos demais integrantes das agências e subagências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social.",
        },
        {
          key: "7",
          name: "Investigação I",
          help: "§8º. O nível Investigação I apenas poderá ser concedido aos integrantes da Polícia Civil lotados na Delegacia de Assuntos Internos (DAI-CGD).",
        },
        {
          key: "8",
          name: "Investigação II",
          help: "§9º. O nível Investigação II apenas poderá ser concedido aos integrantes da Polícia Civil lotados na Delegacia de Repressão às Ações Criminosas Organizadas (DRACO-PCCE).",
        },
        {
          key: "9",
          name: "Investigação III",
          help: "§10. O nível Investigação III poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias Especializadas do Grupo 3, conforme Anexo II.",
        },
        {
          key: "10",
          name: "Investigação IV",
          help: "§11. O nível Investigação IV poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias Especializadas do Grupo 2, conforme Anexo II.",
        },
        {
          key: "11",
          name: "Investigação V",
          help: "§12. O nível Investigação V poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias do Grupo 1, conforme Anexo II.",
        },
        {
          key: "12",
          name: "Investigação VI",
          help: (
            <>
              <p>
                §13. O nível Investigação VI poderá ser concedido aos
                integrantes da Polícia Civil lotados nas demais Unidades
                Policiais.
              </p>
              <p>
                §15. Os integrantes da Perícia Forense do Ceará poderão ter
                acesso ao nível Investigação VI. Ademais, poderão ter acesso aos
                procedimentos policiais em que estejam atuando, o que deverá ser
                solicitado a COTIC-SSPDS por meio de sistema próprio,
                comprovando-se a atuação no procedimento.
              </p>
            </>
          ),
        },
        {
          key: "13",
          name: "Operacional I",
          help: "§16. O nível Operacional I poderá ser concedido aos agentes de Segurança Pública que executem atividades de policiamento ostensivo e atividades bombeiro militar, especificamente aos oficiais do policiamento ostensivo, aos oficiais bombeiros militares e aos praças comandantes Unidades Policiais.",
        },
        {
          key: "14",
          name: "Operacional II",
          help: "§17. O nível Operacional II poderá ser concedido aos agentes de Segurança Pública que executem atividades de policiamento ostensivo e atividades bombeiros militares, especificamente aos policiais militares e bombeiros militares do policiamento ostensivo ou da atividade fim bombeiro militar não elencados no parágrafo anterior.",
        },
        {
          key: "15",
          name: "Externo I",
          help: "§19. Aos agentes públicos externos a SSPDS que tenham a necessidade de acessar o sistema Consulta Integrada, poderá ser concedido acesso no nível Externo I ou Externo II, a depender da atividade que desenvolva, sendo necessária a celebração de Termo de Cooperação Técnica com a SSPDS.",
        },
        {
          key: "16",
          name: "Externo II",
          help: "§19. Aos agentes públicos externos a SSPDS que tenham a necessidade de acessar o sistema Consulta Integrada, poderá ser concedido acesso no nível Externo I ou Externo II, a depender da atividade que desenvolva, sendo necessária a celebração de Termo de Cooperação Técnica com a SSPDS.",
        },
      ],
    },
    {
      key: 3,
      app: "SIP3W",
      groups: [
        {
          key: "1",
          name: "Inteligência I",
          help: "§2o. O nível Inteligência I poderá ser concedido aos Policiais Civis integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Contrainteligência (Coordenadores, Diretores e agentes lotados em Células de Contrainteligência formalizadas no âmbito da COIN-SSPDS e do DIP-PCCE), bem como aos Policiais Civis integrantes da Coordenadoria de Inteligência da Controladoria Geral de Disciplina dos Órgãos de Segurança Pública e do Sistema Penitenciário (COINT-CGD), com a limitação de, no máximo, 3 acessos por agência.",
        },
        {
          key: "2",
          name: "Inteligência II",
          help: "§3o. O nível Inteligência II poderá ser concedido aos demais Policiais Civis integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Contrainteligência (agentes lotados em Células de Contrainteligência formalizadas no âmbito da COIN-SSPDS e do DIP-PCCE), bem como aos demais Policiais Civis integrantes da Coordenadoria de Inteligência da Controladoria Geral de Disciplina dos Órgãos de Segurança Pública e do Sistema Penitenciário (COINT-CGD).",
        },
        {
          key: "3",
          name: "Inteligência III",
          help: "§4o. O nível Inteligência III poderá ser concedido aos Policiais Civis integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Inteligência propriamente dita (Coordenadores, Diretores e agentes lotados em Células de Inteligência formalizadas no âmbito da COIN-SSPDS e do DIP-PCCE), com a limitação de, no máximo, 3 acessos por agência.",
        },
        {
          key: "4",
          name: "Inteligência IV",
          help: "§5º. O nível Inteligência IV poderá ser concedido aos demais Policiais Civis integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social, que executem atividades na área de Inteligência propriamente dita (agentes lotados em Células de Inteligência formalizadas no âmbito da COIN-SSPDS e do DIP-PCCE).",
        },
        {
          key: "5",
          name: "Inteligência V",
          help: (
            <>
              <p>
                6o. O nível Inteligência V poderá ser concedido aos Policiais
                Civis integrantes das agências de inteligência, no âmbito da
                Secretaria da Segurança Pública e Defesa Social (agentes lotados
                na COIN-SSPDS e no DIP-PCCE), que executem atividades nas demais
                áreas de análise.
              </p>
              <p>
                §18. Poderá ser disponibilizado para a Superintendência de
                Pesquisa e Estratégia de Segurança Pública (SUPESP) até 2 (dois)
                pontos de acesso ao Sistema SIP3W, no nível Inteligência V.
              </p>
            </>
          ),
        },
        {
          key: "6",
          name: "Inteligência VI",
          help: "§7o. O nível Inteligência VI poderá ser concedido aos demais Policiais Civis integrantes das agências e subagências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social.",
        },
        {
          key: "7",
          name: "Investigação I",
          help: "§8º. O nível Investigação I apenas poderá ser concedido aos integrantes da Polícia Civil lotados na Delegacia de Assuntos Internos (DAI-CGD).",
        },
        {
          key: "8",
          name: "Investigação II",
          help: "§9º. O nível Investigação II apenas poderá ser concedido aos integrantes da Polícia Civil lotados na Delegacia de Repressão às Ações Criminosas Organizadas (DRACO-PCCE).",
        },
        {
          key: "9",
          name: "Investigação III",
          help: "§10. O nível Investigação III poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias Especializadas do Grupo 3, conforme Anexo III.",
        },
        {
          key: "10",
          name: "Investigação IV",
          help: "§11. O nível Investigação IV poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias Especializadas do Grupo 2, conforme Anexo III.",
        },
        {
          key: "11",
          name: "Investigação V",
          help: "§12. O nível Investigação V poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias do Grupo 1, conforme Anexo III.",
        },
        {
          key: "12",
          name: "Investigação VI",
          help: (
            <>
              <p>
                §13. O nível Investigação VI poderá ser concedido aos
                integrantes da Polícia Civil lotados nas demais Unidades
                Policiais.
              </p>
              <p>
                §15. Os integrantes da Perícia Forense do Ceará poderão ter
                acesso ao nível Investigação VI. Ademais, poderão ter acesso aos
                procedimentos policiais em que estejam atuando, o que deverá ser
                solicitado a COTIC-SSPDS por meio de sistema próprio,
                comprovando-se a atuação no procedimento.
              </p>
            </>
          ),
        },
        {
          key: "13",
          name: "Externo",
          help: (
            <>
              <p>
                §16. Aos demais agentes de Segurança Pública e outros agentes
                públicos que tenham a necessidade de utilizar o sistema SIP3W e
                que não se enquadrem exatamente nos parágrafos anteriores,
                poderá ser concedido acesso no nível Externo mencionado no Anexo
                III, sendo necessário, para tanto, a celebração de Termo de
                Cooperação Técnica com a SSPDS, para agentes externos à
                Secretaria, com a devida participação da Comissão de Gestão do
                Aplicativo Sistema de Informações Policiais (SIP3W).
              </p>
              §17. Poderão ser disponibilizados para a ASINT-PMCE e para a
              ASSINT-CBMCE até 2 (dois) pontos e senhas de acesso ao Sistema
              SIP3W, no nível Externo.
            </>
          ),
        },
      ],
    },
    {
      key: 4,
      app: "CEREBRUM",
      groups: [
        {
          key: "1",
          name: "Inteligência I",
          help: (
            <>
              <p>
                §2o. O nível Inteligência I poderá ser concedido aos integrantes
                das agências de inteligência, no âmbito da Secretaria da
                Segurança Pública e Defesa Social (agentes lotados em Células de
                Inteligência e Contrainteligência formalizadas no âmbito da
                COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE), que executem
                atividades na área de Inteligência propriamente dita e
                Contrainteligência.
              </p>
              <p>
                §12. Ao Secretário de Segurança Pública e Defesa Social, ao
                Delegado Geral da Polícia Civil, ao Comandante Geral da Polícia
                Militar, ao Comandante Geral do Corpo de Bombeiros Militar, ao
                Perito Geral da PEFOCE e ao Coordenador de Inteligência da SSPDS
                poderá ser concedido acesso ao nível Inteligência I do Cerebrum.
              </p>
              <p>
                §13. Aos agentes de Segurança Pública lotados na
                Superintendência de Pesquisa e Estratégia de Segurança Pública
                (SUPESP) poderá ser concedido acesso no nível Inteligência I.
              </p>
            </>
          ),
        },
        {
          key: "2",
          name: "Inteligência II",
          help: "§3o. O nível Inteligência II poderá ser concedido aos integrantes das agências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social (agentes lotados na COIN-SSPDS, no DIP-PCCE e na ASINT-PMCE), que executem atividades nas demais áreas de análise.",
        },
        {
          key: "3",
          name: "Inteligência III",
          help: "§4o. O nível Inteligência III poderá ser concedido aos demais integrantes das agências e subagências de inteligência, no âmbito da Secretaria da Segurança Pública e Defesa Social.",
        },
        {
          key: "4",
          name: "Investigação I",
          help: "§5o. O nível Investigação I poderá ser concedido aos integrantes da Polícia Civil ocupantes do cargo de Delegado de Polícia Civil, bem como de Inspetor e Escrivão de Polícia Civil, desde que chefes de Investigação e de Cartório, respectivamente, nesses dois últimos casos, e desde que lotados em Delegacias Especializadas, bem como aos oficiais da Coordenadoria de Polícia Judiciária Militar (CPJM-PMCE) e da Comissão de Apuração de Procedimentos e Disciplina (CAPD-CBM).",
        },
        {
          key: "5",
          name: "Investigação II",
          help: "§6º. O nível Investigação II poderá ser concedido aos integrantes da Polícia Civil ocupantes do cargo de Delegado de Polícia Civil, bem como de Inspetor e Escrivão de Polícia Civil, desde que chefes de Investigação e de Cartório, respectivamente, nesses dois últimos casos, não lotados em Delegacias Especializadas, bem como aos policiais e bombeiros militares da CPJM e da CAPD, que exercerem a função de escrivães em inquéritos policiais militares.",
        },
        {
          key: "6",
          name: "Investigação III",
          help: "§7º. O nível Investigação III poderá ser concedido aos integrantes da Polícia Civil ocupantes do cargo de Inspetor e Escrivão de Polícia Civil que não se enquadrem nos parágrafos anteriores, bem como aos demais policiais e bombeiros militares da Coordenadoria de Polícia Judiciária Militar (CPJM-PMCE) e da Comissão de Apuração de Procedimentos e Disciplina (CAPD-CBM), não elencados nos parágrafos anteriores.",
        },
        {
          key: "7",
          name: "Operacional I",
          help: "§8o. O nível Operacional I poderá ser concedido aos agentes de Segurança Pública que executem atividades de policiamento ostensivo e atividades bombeiro militar, especificamente aos oficiais do policiamento ostensivo, aos oficiais bombeiros militares e aos praças comandantes de grupos de serviço em suas escalas regulares.",
        },
        {
          key: "8",
          name: "Operacional II",
          help: "§9º. O nível Operacional II poderá ser concedido aos agentes de Segurança Pública que executem atividades de policiamento ostensivo e atividades bombeiro militar, especificamente aos policiais militares e bombeiros militares comandantes de viaturas e/ou de frações Policiais Militares e Bombeiros Militares em outras modalidades de policiamento ostensivo ou bombeiro militar.",
        },
        {
          key: "9",
          name: "Operacional III",
          help: "§10. O nível Operacional III poderá ser concedido aos agentes de Segurança Pública que executem atividades de policiamento ostensivo e atividades bombeiros militares, especificamente aos policiais militares e bombeiros militares do policiamento ostensivo ou da atividade fim bombeiro militar não elencados nos parágrafos anteriores.",
        },
        {
          key: "10",
          name: "EXTERNO",
          help: "",
        },
      ],
    },
    {
      key: 5,
      app: "AGILIS",
      groups: [
        {
          key: "1",
          name: "Inteligência I",
          help: (
            <>
              <p>
                §2o. O nível Inteligência I poderá ser concedido aos integrantes
                da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE, que executem
                atividades na área de Inteligência propriamente dita, de
                Contrainteligência e de Operações (células formalmente criadas)
              </p>
              <p>
                §11. Ao Secretário de Segurança Pública e Defesa Social, ao
                Delegado Geral da Polícia Civil e ao Comandante Geral da Polícia
                Militar do Ceará, poderá ser concedido acesso ao nível
                Inteligência I do sistema AGILIS.
              </p>
              <p>
                {" "}
                §12. Aos agentes de Segurança Pública lotados na
                Superintendência de Pesquisa e Estratégia de Segurança Pública
                (SUPESP) poderá ser concedido acesso no nível Inteligência I.
              </p>
            </>
          ),
        },
        {
          key: "2",
          name: "Inteligência II",
          help: "§3o. O nível Inteligência II poderá ser concedido aos demais integrantes da COIN-SSPDS, do DIP-PCCE e da ASINT-PMCE.",
        },

        {
          key: "3",
          name: "Investigação I",
          help: "§4º. O nível Investigação I apenas poderá ser concedido aos integrantes da Polícia Civil lotados nas Delegacias Especializadas.",
        },
        {
          key: "4",
          name: "Investigação II",
          help: (
            <>
              <p>
                §5º. O nível Investigação II apenas poderá ser concedido aos
                integrantes da Polícia Civil lotados nas demais Delegacias de
                Polícia Civil que executem atividade eminentemente
                investigativa.
              </p>
              <p>
                §10. Aos agentes públicos externos a SSPDS que tenham a
                necessidade de acessar o sistema AGILIS, poderá ser concedido
                acesso no nível Investigação II ou Operacional III, a depender
                da atividade que desenvolva, sendo necessária a celebração de
                Termo de Cooperação Técnica com a SSPDS.
              </p>
            </>
          ),
        },
        {
          key: "5",
          name: "Investigação III",
          help: (
            <>
              <p>
                §5º. O nível Investigação II apenas poderá ser concedido aos
                integrantes da Polícia Civil lotados nas demais Delegacias de
                Polícia Civil que executem atividade eminentemente
                investigativa.
              </p>
              <p>
                §10. Aos agentes públicos externos a SSPDS que tenham a
                necessidade de acessar o sistema AGILIS, poderá ser concedido
                acesso no nível Investigação II ou Operacional III, a depender
                da atividade que desenvolva, sendo necessária a celebração de
                Termo de Cooperação Técnica com a SSPDS.
              </p>
            </>
          ),
        },
        {
          key: "6",
          name: "Operacional I",
          help: "§6º. O nível Operacional I poderá ser concedido aos agentes de Segurança Pública que executem atividades na CIOPS da capital e do interior do Estado, especificamente aos ocupantes das funções de Controlador de Turno de Videomonitoramento e de Despachante de Ocorrências.",
        },
        {
          key: "7",
          name: "Operacional II",
          help: "§7º. O nível Operacional II poderá ser concedido aos agentes de Segurança Pública que executem atividades nos Centros de Operações Policiais Militares (COPOMs) do interior do Estado.",
        },
        {
          key: "8",
          name: "Operacional III",
          help: (
            <>
              <p>
                §8º. O nível Operacional III poderá ser concedido aos agentes de
                Segurança Pública que executem atividades na CIOPS da capital e
                do interior do Estado, bem como nos COPOMs, especificamente aos
                ocupantes das funções de Operador de Videomonitoramento.
              </p>
              <p>
                §10. Aos agentes públicos externos a SSPDS que tenham a
                necessidade de acessar o sistema AGILIS, poderá ser concedido
                acesso no nível Investigação II ou Operacional III, a depender
                da atividade que desenvolva, sendo necessária a celebração de
                Termo de Cooperação Técnica com a SSPDS.
              </p>
            </>
          ),
        },
      ],
    },
    {
      key: 6,
      app: "ROTAS",
      groups: [
        {
          key: "1",
          name: "Inteligência I",
          help: <></>,
        },
        {
          key: "2",
          name: "Inteligência II",
          help: <></>,
        },
        {
          key: "3",
          name: "Inteligência III",
          help: <></>,
        },
        {
          key: "4",
          name: "Inteligência IV",
          help: <></>,
        },
        {
          key: "5",
          name: "Investigação I",
          help: <></>,
        },
        {
          key: "6",
          name: "Investigação II",
          help: <></>,
        },
        {
          key: "7",
          name: "Investigação III",
          help: <></>,
        },
        {
          key: "8",
          name: "Investigação IV",
          help: <></>,
        },
        {
          key: "9",
          name: "OSTENSIVO I",
          help: <></>,
        },
        {
          key: "10",
          name: "OSTENSIVO II",
          help: <></>,
        },
        {
          key: "11",
          name: "OSTENSIVO III",
          help: <></>,
        },
        {
          key: "12",
          name: "CBM I",
          help: <></>,
        },
        {
          key: "13",
          name: "CBM II",
          help: <></>,
        },
        {
          key: "14",
          name: "CBM III",
          help: <></>,
        },
        {
          key: "15",
          name: "CBM IV",
          help: <></>,
        },
        {
          key: "16",
          name: "PERÍCIA I",
          help: <></>,
        },
        {
          key: "17",
          name: "PERÍCIA II",
          help: <></>,
        },
        {
          key: "18",
          name: "PERÍCIA III",
          help: <></>,
        },
        {
          key: "19",
          name: "AUDITORIA I",
          help: <></>,
        },
      ],
    },
    {
      key: 7,
      app: "APOLO PROCUMPRI",
      groups: [
        {
          key: "1",
          name: "Inteligência 01",
          help: <></>,
        },
        {
          key: "2",
          name: "Inteligência 02",
          help: <></>,
        },
        {
          key: "3",
          name: "Inteligência 03",
          help: <></>,
        },
        {
          key: "4",
          name: "Supervisão 01",
          help: <></>,
        },
        {
          key: "5",
          name: "Supervisão 02",
          help: <></>,
        },
        {
          key: "6",
          name: "GERENCIAL 01",
          help: <></>,
        },
        {
          key: "7",
          name: "GERENCIAL 02",
          help: <></>,
        },
      ],
    },
    {
      key: 8,
      app: "APOLO SAP",
      groups: [
        {
          key: "1",
          name: "Avançado",
          help: <></>,
        },
        {
          key: "2",
          name: "Básico",
          help: <></>,
        },
        {
          key: "3",
          name: "Inteligência",
          help: <></>,
        },
      ],
    },
  ];
}
